<template>
  <Transition name="modal">
    <div v-if="props.showModal" id="modalPopupZoom">
      <div class="modal-container">
        <div class="modal-header">
          <button class="close-black" @click="emit('close')">
            <img
              src="https://api.belladasemana.com.br/storage/2015/ico_x_black-t.png"
              alt="Close"
              class="close-modal"
            />
          </button>
        </div>
        <div class="modal-body text-center">
          <div class="orange-text">
            {{ translate.modalZoomTitle }}
          </div>
          <div class="black-text py-4">
            {{ translate.modalZoomText }}
          </div>
          <div class="bt-zoom" @click="redirectPage()">
            {{ translate.modalZoomButton }}
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import translateModel from "@/tradutors/model";

const router = useRouter();
const route = useRoute();

const translate = computed(() =>
  route.params.language === "pt-br" ? translateModel.portugues : translateModel.ingles
);

const props = defineProps({
  showModal: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["close"]);

function redirectPage() {
  router.push({
    name: "language-assine",
    params: { language: route.params.language },
  });
}
</script>

<style scoped>
.modal-container {
  position: fixed;
  z-index: 9998;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 620px;
  margin: auto;
  padding: 40px 30px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  border: 1px solid transparent;
  border-radius: 54px;
  background:
    linear-gradient(white, white) padding-box,
    linear-gradient(to bottom, #FF6000, #FFC39E) border-box;
  background-clip: padding-box, border-box;
  background-origin: padding-box, border-box;
}

.modal-header {
  display: block;
  text-align: center;
}

.modal-body {
  margin: 0;
  padding: 0px 20px;
}

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.close-black {
  position: absolute;
  right: -25px;
  top: -56px;
  z-index: 1;
}

.orange-text {
  color: #ff6000;
  font-family: "Exo-2";
  font-weight: 700;
  font-size: 30px;
  letter-spacing: -1px;
  line-height: 100%;
}

.black-text {
  color: #000000;
  font-family: "Exo-2";
  font-weight: 400;
  font-size: 18px;
  letter-spacing: 0;
  line-height: 140%;
}

.bt-zoom {
  background-color: #ff6000;
  color: #ffffff;
  font-family: "Exo-2";
  font-weight: 700;
  font-size: 18px;
  letter-spacing: 0;
  line-height: 20px;
  padding: 12px 20px;
  border-radius: 7px;
  cursor: pointer;
  width: 350px;
  margin: 0 auto;
}

@media screen and (max-width: 769px) {
  .modal-container {
    width: 95%;
  }

  .close-modal {
    width: 25px;
    height: 25px;
    margin: 5px;
  }

  .orange-text {
    font-size: 20px;
  }

  .black-text {
    font-size: 16px;
  }

  .bt-zoom {
    width: 100%;
    font-size: 14px;
  }

  .close-black {
    right: -20px;
    top: -63px;
  }
}
</style>
